import React, {Component} from "react";
import {connect} from "react-redux";

import Map from "./../components/map/Map";
import InfoBox from "../components/map/InfoBox";
import StatsBox from "../components/map/StatsBox";
import MapTooltip from "./../components/map/MapTooltip";

import {FILE_KEYS} from "./../helpers/consts";
import {loadDataAction} from "./../actions/DataAction";

//Views
import RegionalCluster from "../views/map/RegionalCluster";
import Employment from "../views/map/Employment";
import Occupational from "../views/map/Occupational";

import "./MapViewLayout.css";

class MapViewLayout extends Component {

  componentDidMount() {
    this.props.loadDataAction([
      FILE_KEYS.CLUSTERS_REFERENCE,
      FILE_KEYS.COUNTRIES_REFERENCE,
      FILE_KEYS.URBAN_REFERENCE,
      FILE_KEYS.NUTS3_SHAPES,
      FILE_KEYS.METRO_STATS,
      FILE_KEYS.NUTS3_PRESENT,
      FILE_KEYS.ISCO_REFERENCE
    ], this.props.db);
  }

  render() {
    const {hashParts} = this.props;
    return (
      <div id="fow-map-view-layout">
        <InfoBox />
        <div id="fow-map-row">
          <div className="fow-inner-container">
            <div id="fow-map-layout-row" className="fow-row">
              <div className="fow-col fow-col-1">
                <MapTooltip />
                <Map />
                <StatsBox />
              </div>
            </div>
          </div>
        </div>
        {hashParts.view === "regional-cluster" && <RegionalCluster />}
        {hashParts.view === "employment" && <Employment />}
        {hashParts.view === "occupational" && <Occupational />}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    db: state.db,
    hashParts: state.settings.hashParts
  };
};
const mapDispatchToProps = dispatch => ({
  loadDataAction: (keys, db) => dispatch(loadDataAction(keys, db)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MapViewLayout);
